<template>
  <div class="cont-cont">
    <div class="list" v-for="(item,i)  in obj" :key="i" :id="'order_list'+i">
      <img class="list_img" :src="item.picUrl?item.picUrl:img" alt />
      <div class="orderHomeBox">
        <div class="display_flex display_flex1">
          <div style="overflow: hidden;width: 100%">
            <p class="sL">{{ item.goodsName }}</p>
            <div class="sl_right" style="float: right">
              <p class="sT" v-if="active == 0">
                <img src="./img/jifen.png" alt />
                +{{ item.oneCommission }}
              </p>

              <p class="sT" v-if="active == 1">
                <img src="./img/jifen.png" alt />
                +{{ item.twoCommission }}
              </p>

              <p class="goods_text_left" v-if="active == 2">
                ¥
                <span>{{ (item.payPrice.split(".")[0]) }}</span>
                .{{ (item.payPrice.split(".")[1]) }}
              </p>
            </div>
          </div>
        </div>
        <p class="display_flex display_flex2">
          <span>订单编号：</span>
          <span>{{ item.mainOrderNo }}</span>
        </p>
        <p class="display_flex display_flex3">
          <span>下单时间：</span>
          <span>{{ item.orderCreate }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderData",
  props: {
    obj: Array,
    active: Number,
    img: String
  },

  created() {
    this.obj.forEach((item, index) => {
      this.$nextTick(() => {
        this.$trackFn.load("order_list" + index, "view_material", {
          // 曝光 - 埋点
          page_type: "order_list",
          card_type: "order_list",
          material_id: item.mainOrderNo,
          material_type: "order_no"
        });
      });
    });
  }
};
</script>

<style scoped>
.goods_text_left {
  color: #dd2b1e;
  font-size: 24px;
  align-items: baseline;
  position: relative;
  top: -6px;
}

.goods_text_left span {
  font-size: 36px;
}
.cont-cont {
  padding: 20px 30px;
}

.list {
  padding: 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.list_img {
  width: 160px;
  margin-right: 20px;
  border-radius: 12px;
}

.display_flex {
  display: flex;
  align-items: center;
}

.display_flex1 {
  margin-bottom: 20px;
}

.display_flex2 {
  margin-bottom: 4px;
  color: #999;
}

.display_flex3 {
  color: #999;
}

.sT {
  display: flex;
  align-items: center;
  height: 28px;
  background: rgba(255, 167, 46, 0.09);
  border-radius: 30px;
  color: #ffa72e;
  justify-content: center;
  padding: 4px 8px;
}

.sT img {
  width: 28px;
  height: 28px;
}

.sL {
  width: 60%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  font-size: 30px;
  float: left;
}

.sl_right {
  position: relative;
}
.orderHomeBox {
  width: 470px;
}
</style>
